import { createClient } from "@supabase/supabase-js";
import { clearOnLogout, env } from "@/lib/utils";

const supabaseUrl = env("VITE_SUPABASE_URL");
const supabasePublishableKey = env("VITE_SUPABASE_PUBLISHABLE_KEY");

// Any request (auth or rpc) coming back 401 means the session is no longer
// valid on the server, even though a (stale) token may still sit in storage.
// Force a logout and send the user back to the login screen when that happens.
const fetchWithUnauthorizedHandling: typeof fetch = async (...args) => {
  const response = await fetch(...args);

  if (response.status === 401 && window.location.pathname !== "/login") {
    clearOnLogout();
    window.location.href = "/login";
  }

  return response;
};

export const supabase = createClient(supabaseUrl, supabasePublishableKey, {
  global: { fetch: fetchWithUnauthorizedHandling },
});